import { REQUEST, SUCCESS, FAILURE, CANCEL, CANCELLED } from './redux-types';
import omit from 'lodash/omit';
import merge from 'lodash/merge';

// eslint-disable-next-line no-restricted-syntax -- TODO: legacy function declaration (baseline)
function request({ queryId, payload }) {
    return { type: REQUEST, payload, queryId };
}

// eslint-disable-next-line no-restricted-syntax -- TODO: legacy function declaration (baseline)
function cancel(queryId) {
    return { type: CANCEL, queryId };
}

export const actions = { request, cancel };

export const selector = state => state.restQueries;

const initialState = {
    entities: {},
    responses: {},
    payloads: {}
};

const moduleRestQuery = (state = initialState, action) => {
    const { type } = action;
    const { entities, responses, payloads } = state;
    // eslint-disable-next-line no-restricted-syntax -- TODO: legacy forEach/switch (baseline)
    switch (type) {
        case REQUEST:
            return {
                entities,
                payloads: { ...payloads, [action.queryId]: action.payload },
                responses: { ...responses, [action.queryId]: { ...responses[action.queryId], processing: true } }
            };
        case SUCCESS:
            return {
                entities: action.entities ? merge({}, entities, action.entities) : entities,
                payloads,
                responses: { ...responses, [action.queryId]: { data: action.data, processing: false } }
            };
        case FAILURE:
            return {
                entities,
                payloads,
                responses: { ...responses, [action.queryId]: { error: action.error, processing: false } }
            };
        case CANCELLED:
            return {
                entities,
                responses: omit(state.responses, action.queryId),
                payloads: omit(state.payloads, action.queryId)
            };
        default:
            return state;
    }
};
export default moduleRestQuery;
